import { useContext, React, useEffect, useState } from "react";
import { Container, Row, Col, Tab, Tabs } from "react-bootstrap";
import { HomePageContext } from "../HomePageView";
import "./homePage.css";
import BannerShape from "../../../assets/BannerShape.svg";
import ButtonComponent from "../../../components/ButtonComponent/ButtonComponent";
import VguardHoriz from "../../../assets/VgaurdHorizontal.svg";
import VguardVertical from "../../../assets/VgaurdVertical.svg";
import Devices from "../../../assets/devices.svg";
import Constants from "../../../constants/Contents.json";
import ResetPopups from "../../../components/CommonPopup/CommonPopup";
import ConformationImg from "../../../assets/confirmation.svg";
import CallIcon from "../../../assets/images/call.svg";
import EmailIcon from "../../../assets/images/email.svg";
import WhtsappIcon from "../../../assets/images/whtsapp.svg";
import ErrorImage from "../../../assets/error.svg";
import { Element, Link as ScrollLink } from "react-scroll";
import { motion } from "framer-motion";
import {
  fromBottom,
  fromLeft,
  fromRight,
  scaleFromRightCorner,
} from "../../../utils/AnimationStyles";
import "./homePage.css";
import { useNavigate } from "react-router-dom";
import HomePowerPlaning from "./HomePowerPlaning";
import Loader from "../../../components/Loader/Loader";
import { useParams } from "react-router-dom";
const HomePage = () => {
  const {
    consumptionValue,
    hours,
    restrictPowerData,
    handlePowerDecrement,
    handlePowerIncrement,
    handleSideBarChange,
    handleSubmitProduct,
    resetPopup,
    conformationData,
    setResetPopup,
    setHasChanges,
    loaderStatus,
    errorPopup,
    setErrorPopup,
    errorMessage,
    handleContactClick,
    urlStore,
  } = useContext(HomePageContext);
  const navigate = useNavigate();
  const { domain } = useParams();
  return (
    <div className="vgHome-page">
      <div className="homePageContainer">
        <div className="homePageTopBanner">
          {/* Main Text Group */}
          <motion.div
            className="mainTextGroup"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.div
              className="mainText"
              variants={fromLeft}
              custom={0} // First element, no delay
            >
              <span>{Constants.homePage.letsPlanYour}</span>
              <span style={{ color: "#FDB426" }}>
                {Constants.homePage.powerPlanning}
              </span>
            </motion.div>

            <motion.div
              className="description"
              variants={fromLeft}
              custom={1} // Second element, will be delayed by 0.3 seconds
            >
              <span>{Constants.homePage.pwrSlns}</span>
              <span>{Constants.homePage.perfectInverter}</span>
            </motion.div>
            {/* <span className="description"></span> */}
            <div className="btngrp homePageTopBtns">
              <ScrollLink to="letsAdd" smooth={true} duration={400}>
                <motion.div variants={fromBottom} custom={0}>
                  <ButtonComponent buttonText="Let's Plan" type="filled" />
                </motion.div>
              </ScrollLink>
              <ScrollLink
                to={urlStore === "com" ? "conatctSection" : ""}
                onClick={urlStore !== "com" ? handleContactClick : undefined}
                smooth={true}
                duration={400}
              >
                <motion.div variants={fromBottom} custom={1}>
                  <ButtonComponent
                    buttonText="Contact Us"
                    type="transparent"
                    onClick={handleContactClick}
                  />
                </motion.div>
              </ScrollLink>
            </div>
          </motion.div>

          {/* Image Section */}
          <motion.div
            className="imageSection"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.img
              src={BannerShape}
              variants={scaleFromRightCorner}
              custom={0}
              className="bannerImageSection"
            />
            <motion.img
              className="devicesImage"
              src={Devices}
              variants={scaleFromRightCorner}
            />
          </motion.div>

          {/* Vgaurd Horz and Vert */}
          <motion.div
            className="vguardHoriz"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.img src={VguardHoriz} variants={scaleFromRightCorner} />
          </motion.div>
        </div>
        <motion.div
          className="vguardVertical"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.img src={VguardVertical} variants={fromBottom} />
        </motion.div>
      </div>

      <Container>
        {loaderStatus && <Loader />}
        <Element name="letsAdd">
          <HomePowerPlaning />
        </Element>

        <motion.div
          // className="powerBtnSection"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fromBottom}
          custom={1}
        >
          <div className="powerBtnSection">
            <Row>
              <Col sm="12" lg="6">
                <div className="power-backup-container">
                  <h4>{Constants?.homePage?.powerBackupHead}</h4>
                  <div className="power-backup-controls">
                    <span>{Constants?.homePage?.requireData}</span>
                    <div className="control-group">
                      <button
                        className="control-button decrement"
                        onClick={handlePowerDecrement}
                        disabled={hours === 1}
                      >
                        -
                      </button>
                      <span className="hours-display">
                        <input
                          className="enterHours"
                          type="number"
                          value={hours}
                          onChange={restrictPowerData}
                        />
                      </span>
                      <button
                        className="control-button increment"
                        onClick={handlePowerIncrement}
                        disabled={hours === 10}
                      >
                        +
                      </button>
                    </div>
                    <span className="hoursDescribeText">
                      {Constants?.homePage?.hoursBack}
                    </span>
                  </div>
                </div>
              </Col>

              <Col sm="12" lg="6">
                <div className="slider-container">
                  <div className="slider-header">
                    <span>{Constants?.homePage.avgConsumption}</span>
                    <span className="slider-value">
                      {consumptionValue}
                      {Constants?.homePage?.percetage}
                    </span>
                  </div>
                  <div className="slider-bar-container">
                    <input
                      type="range"
                      min={20}
                      max={100}
                      value={consumptionValue}
                      onChange={handleSideBarChange}
                      className="slider-bar"
                    />
                    <div className="slider-labels">
                      <span>20%</span>
                      <span>100%</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="dataPlan">
            <ButtonComponent
              id="submitProductData"
              buttonText={Constants?.homePage.letPlan}
              className={"letsPlan"}
              onClick={() => handleSubmitProduct()}
            />
          </div>
          {urlStore == "com" && (
            <div className="contactUsSection">
              <Element name="conatctSection">
                <div className="contactUsData">
                  <div className="contactMessage">
                    <img src={CallIcon} alt="call" />
                    <span>{Constants?.homePage.call}</span>
                  </div>
                  <div className="contactMessage">
                    <img src={EmailIcon} alt="email" />
                    <span>{Constants?.homePage?.emailSend}</span>
                  </div>
                  <div className="contactMessage">
                    <img src={WhtsappIcon} alt="whtsapp call" />
                    <span>{Constants?.homePage?.whtsappCall}</span>
                  </div>
                </div>
              </Element>
            </div>
          )}
        </motion.div>
      </Container>
      <ResetPopups
        image={ConformationImg}
        show={resetPopup}
        title={Constants?.HomePage?.areSure}
        description={Constants?.homePage?.messageSure}
        buttonText="Proceed"
        onSubmit={conformationData}
        handleClose={() => setResetPopup(false)}
      />
      <ResetPopups
        show={errorPopup}
        image={ErrorImage}
        isClose={false}
        onSubmit={() => setErrorPopup(false)}
        title={Constants.productPage.error}
        buttonText="Close"
        description={errorMessage}
      />
    </div>
  );
};

export default HomePage;
